



















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { CourseStructViewModel, CourseStructService } from '../../api/courseStruct';
@Component({})
export default class StructTree extends Vue {
  @Prop() private bookId!: number;
  @Prop() private bookGuid!: string;
  private service: CourseStructService = new CourseStructService();
  private data: any[] = [];
  private mounted() {
    this.service.GetByBookGuid(this.bookGuid).then((response: any) => {
      response[0].name += ' 目录';
      this.data = response;
      this.OnChange(response[0], undefined);
      this.$nextTick(() => {
        (this.$refs.structTree as any).setCurrentKey(response[0].id);
      });
    });
  }

  @Emit('OnChange')
  private OnChange(data: any, node: any) {
    return data;
  }
}
